// src/components/RequireAuth.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../Context/AuthContext';

const RequireAuth = ({ children, redirectTo = '/' }) => {
  const { token } = useContext(AuthContext);

  if (!token) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default RequireAuth;